import React from "react";
import { useLocation } from "react-router-dom";
import AddNewUser from "./AddNewUser";
import AddAccessRight from "./AddAccessRight";
import InsertStation from "./InsertStation";
const AdminControlPanel = ({ from }) => {
  const location = useLocation();
  const payload = location.state;
  const pages = {
    "Add User": <AddNewUser />,
    "Add Access Rights": <AddAccessRight />,
    "Add Station": <InsertStation />,
  };
  return (
    <div
      style={{ background: "#253343ff", minHeight: "100vh", color: "white" }}
    >
      <h5 className="text-center pt-2">
        {payload.from}
        <hr />
      </h5>
      {pages[payload.from]}
    </div>
  );
};
export default AdminControlPanel;
